import type { FiltersContextProviderProps } from '@openx/components-filters/lib/context/types.ts';
import { FILTER_TYPES } from '@openx/components-filters/lib/FiltersBar/types.ts';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDemandPartnerOptionsFetch } from '../../hooks/useDemandPartnerOptionsFetch.ts';
import type { CuratedDealBuyerDiscountsListFilters } from '../types.ts';

export const useCuratedDealBuyerDiscountChipFilters = (
  criteria: AllTableCriteria<CuratedDealBuyerDiscountsListFilters>,
  handleFiltersChange: (newFilters: CuratedDealBuyerDiscountsListFilters) => void
) => {
  const { isLoading, list } = useDemandPartnerOptionsFetch();
  const { t } = useTranslation();

  return useMemo<FiltersContextProviderProps<CuratedDealBuyerDiscountsListFilters>['config']>(
    () => ({
      criteria,
      disabledFilters: [],
      filtersConfig: [
        {
          key: 'demand_partner_id',
          name: t('Demand Partner'),
          type: FILTER_TYPES.AUTOCOMPLETE,
          options: list,
          config: {
            emptyPlaceholder: t('[ Select Demand Partner ]'),
            isLoading,
          },
        },
      ],
      onFiltersChange: handleFiltersChange,
      visibleFilters: ['demand_partner_id'],
    }),
    [criteria, handleFiltersChange, isLoading, list, t]
  );
};
